import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/components/navbar.tsx");
